import { getUserInfo, getShoppingCar } from 'common/js/store'

const state = {
  userInfo: getUserInfo({}),
  shopCar: getShoppingCar([]),
  isSendCode: true, // 是否可以点击发送请求验证码按钮
  searchText: '', // 搜索词
  shoCartCount: 0, // 购物车数量
  login: false // 是否显示登录弹窗
}

export default state



// WEBPACK FOOTER //
// ./src/store/state.js